define('shared/util/adyen/rejectWithTokenUpdateFailed',[
    'Promise'
], function (
    Promise
) {
    return function () {
        var err = new Error('Token update failure');
        err.fatal = true;
        err.type = 'paymentUpdateFailed';
        return Promise.reject(err);
    };
});

